import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiDeleteNoAuth, ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- master Inventory Apis ------------------------------
export const create_customer = createAsyncThunk(
    "create_customer",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.create_customer, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_customer = createAsyncThunk(
    "update_customer",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.update_customer, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_customers = createAsyncThunk(
    "get_customers",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_customers, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_customer_by_id = createAsyncThunk(
    "get_customer_by_id",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_customer_by_id, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const countries = createAsyncThunk(
    "countries",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.countries, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const states = createAsyncThunk(
    "states",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.states, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const cities = createAsyncThunk(
    "cities",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.cities, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const delete_customer = createAsyncThunk(
    "delete_customer",
    async (body) => {
        return ApiDeleteNoAuth(BaseUrl, api.delete_customer + body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_items = createAsyncThunk(
    "get_items",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_items, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const create_items = createAsyncThunk(
    "create_items",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.create_items, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_item_by_id = createAsyncThunk(
    "get_item_by_id",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_item_by_id, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const delete_item = createAsyncThunk(
    "delete_item",
    async (body) => {
        return ApiDeleteNoAuth(BaseUrl, api.delete_item + body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_item = createAsyncThunk(
    "update_item",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.update_item, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_gst_rates = createAsyncThunk(
    "get_gst_rates",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_gst_rates, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const create_gst_rate = createAsyncThunk(
    "create_gst_rate",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.create_gst_rate, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_gst_rate = createAsyncThunk(
    "update_gst_rate",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.update_gst_rate, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const delete_gst_rate = createAsyncThunk(
    "delete_gst_rate",
    async (body) => {
        return ApiDeleteNoAuth(BaseUrl, api.delete_gst_rate + body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_payment_terms = createAsyncThunk(
    "get_payment_terms",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_payment_terms, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const create_payment_term = createAsyncThunk(
    "create_payment_term",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.create_payment_term, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_payment_term = createAsyncThunk(
    "update_payment_term",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.update_payment_term, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const delete_payment_term = createAsyncThunk(
    "delete_payment_term",
    async (body) => {
        return ApiDeleteNoAuth(BaseUrl, api.delete_payment_term + body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_invoices = createAsyncThunk(
    "get_invoices",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_invoices, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const create_invoice = createAsyncThunk(
    "create_invoice",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.create_invoice, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_invoice = createAsyncThunk(
    "update_invoice",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.update_invoice, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const delete_invoice = createAsyncThunk(
    "delete_invoice",
    async (body) => {
        return ApiDeleteNoAuth(BaseUrl, api.delete_invoice + body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_invoice_by_id = createAsyncThunk(
    "get_invoice_by_id",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_invoice_by_id, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_monthwise_item_summary = createAsyncThunk(
    "get_monthwise_item_summary",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_monthwise_item_summary, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_customer_invoice_summary = createAsyncThunk(
    "get_customer_invoice_summary",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_customer_invoice_summary, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_customers_by_year_country = createAsyncThunk(
    "get_customers_by_year_country",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_customers_by_year_country, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_countryWise_summary = createAsyncThunk(
    "get_countryWise_summary",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_countryWise_summary, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_customer_summary = createAsyncThunk(
    "get_customer_summary",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_customer_summary, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_avg_item_summary = createAsyncThunk(
    "get_avg_item_summary",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_avg_item_summary, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_ai_insights = createAsyncThunk(
    "get_ai_insights",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.get_ai_insights, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const ai_chat = createAsyncThunk(
    "ai_chat",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.ai_chat, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);